export default __webpack_public_path__ + "static/media/botty-has-issues.1f3bbaff.svg";